import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalComponent } from "../modal/modal.component";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  constructor(private modalService: NgbModal, private router: Router) {}
  isOpen: boolean = false;
  open(content: string, redirect?: string) {
    if( this.isOpen ) return;
    this.isOpen = true;
    const modalRef = this.modalService.open(ModalComponent);
    modalRef.componentInstance.content = content;
    modalRef.result.then(() => {
    this.isOpen = false;  
      if (redirect) this.router.navigate([redirect]);
    });
  }
}
